export default "__VITE_ASSET__DZSt_3nI__"